export default "__VITE_ASSET__712b732f__"